module.exports = __webpack_public_path__ + "img/node.a2d39902.svg";